export default {
    key: "returnRefundPolicy",
    basePath: '/return-refund-policy',
    exclude: false,
  }
  